import { PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import { cn } from "@/lib/utils";

type BottomStudioBarProps = PropsWithChildren<{
  className?: string;
}>;

/**
 * Renders a fixed bottom bar attached to the viewport.
 * Uses a portal to avoid being affected by transformed ancestors (e.g. page entrance animations).
 */
export function BottomStudioBar({ children, className }: BottomStudioBarProps) {
  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      data-tour="generation-bar"
      className={cn(
        "fixed bottom-3 left-1/2 -translate-x-1/2 w-[calc(100%-1.5rem)] sm:w-auto z-50 border border-white/[0.06] bg-[hsl(240_10%_6%/0.85)] backdrop-blur-3xl shadow-[0_8px_40px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.03)_inset] rounded-2xl py-3 md:py-3.5 px-4 md:px-5",
        className
      )}
    >
      {children}
    </div>,
    document.body
  );
}
